import React, { memo } from 'react';

import { Button, Icons } from '@components/common';

import styles from './FlatTreeMavenirButtons.module.scss';

interface IFlatTreeMavenirButtonsProps {
	isDisabledSubmit: boolean;
	isDisabledCancel?: boolean;
	isDisabledReset?: boolean;
	cancelHandler: () => void;
	submitHandler: () => void;
	resetChanges?: () => void;
	submitText?: string;
	cancelText?: string;
}

const FlatTreeMavenirButtons = ({
	isDisabledSubmit,
	isDisabledCancel,
	isDisabledReset,
	cancelHandler,
	submitHandler,
	resetChanges,
	submitText = 'Show result',
	cancelText = 'Clear all',
}: IFlatTreeMavenirButtonsProps) => {
	return (
		<div className={styles.wrapper}>
			<div className={styles.resetButton}>
				{resetChanges && (
					<Button
						disabled={isDisabledReset}
						icon={Icons.refresh()}
						onClick={resetChanges}
						text='Reset'
						withoutBackground
					/>)
				}
			</div>
			<div className={styles.buttons}>
				<Button
					disabled={isDisabledCancel}
					large
					onClick={cancelHandler}
					text={cancelText}
					withoutBackground
				/>
				<Button
					disabled={isDisabledSubmit}
					large
					onClick={submitHandler}
					text={submitText}
				/>
			</div>
		</div>
	);
};

export default memo(FlatTreeMavenirButtons);
